import React from "react";
import "./Footer.css";
import { FaGithub, FaLinkedin, FaEnvelope } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {new Date().getFullYear()} Ayomide.dev. All rights reserved.</p>
        <div className="footer-links">
          <a href="https://github.com/Phenomen9" target="_blank" rel="noopener noreferrer">
            <FaGithub /> GitHub
          </a>
          <a href="https://www.linkedin.com/in/akinwuntan-ayomide-6350a41b6" target="_blank" rel="noopener noreferrer">
            <FaLinkedin /> LinkedIn
          </a>
          <a href="mailto:akinwuntananthony@example.com">
            <FaEnvelope /> Email
          </a>
        </div>
      </div>
    </footer>
  );
}
